@if (true) {
@if (listing && listing.models && listing.models.length > 0) {
<div class="p-t-5 b-t b-col-12">
    <p class="p-l"
       [sizeClass]="'SM: h4, XL: h3'">{{ title || ('Pair it with' | translate) }}</p>
    <!-- slider -->
    <swiper [slidesPerView]="[2.5,2.5,2.4,2.4][client.sizeId]"
            [scrollbar]="{dragSize: 48, draggable: true}"
            [spaceBetween]="12"
            [freeMode]="true"
            class="p-b-5 p-b-2-s p-b-2-m p-r p-l m-t-5 m-t-3-s">
        @for (model of listing.models; track $index; let i = $index) {
        <ng-template swiperSlide>
            <product class="w-12 left"
                     [model]="model"
                     [listPosition]="i"
                     [klevuRecommendationId]="klevuRecommendationId"
                     [gtmImpressionTrack]="{productId: model.id, position: i+1, list: 'Related products'}"
                     [gtmTrackProductClick]="{productId: model.id, position: i+1, list: 'Related products'}"
                     [forceOneImage]="true"
                     [canShowTieredPrice]="true"></product>
        </ng-template>
        }
    </swiper>
</div>
}
}